.bam-image__figure {
  overflow: hidden;
  position: relative;

  &[app-hasRoundedBorder='4'] {
    border-radius: 4px;
  }

  &[app-hasRoundedBorder='8'] {
    border-radius: 8px;
  }

  &[app-hasRoundedBorder='12'] {
    border-radius: 12px;
  }

  &[app-hasRoundedBorder='full'] {
    border-radius: 50%;
  }

  &[app-animated] {
    @include desktop() {
      -webkit-mask-image: -webkit-radial-gradient(white, black);
    }
  }

  &.is-fullwidth {
    width: calc(100vw - 32px);
    max-height: 100%;

    @include desktop {
      width: calc(100vw - 64px);
    }
    max-width: 1400px;
  }
}

.bam-image__source {
  display: block;
  width: 100%;
  object-fit: cover;
  max-inline-size: 100%;
  block-size: auto;

  @include desktop() {
    .bam-image__figure[app-animated] & {
      transition: all .4s ease-out;
    }

    .bam-image__figure[app-animated] & {
      &:hover {
        transform: scale(1.1);
      }
    }
  }
}
